<script setup lang="ts">
import IconButton from "~/components/IconButton.vue";
import UpdateClientModal from "~/features/clients/UpdateClientModal.vue";
import { useClientStore } from "~/store/clients";
import type { Org, Client } from "~/common/types/types";
const store = useClientStore();
const isModalOpen = ref(false);

const props = defineProps({
  client: {
    type: Object as PropType<Client>,
      required: true,
    },  
  });
const clientToUpdate = ref(props.client);

async function submitted(client: Client) {
  await store.updateClient(client);
  isModalOpen.value = false;
}

</script>

<template>
    <div>
        <IconButton @click="isModalOpen = true">Update Client</IconButton>
        <UpdateClientModal
            v-if="isModalOpen"
            v-model="clientToUpdate"
            @close="isModalOpen = false"
            @submitted="submitted"
        />
    </div>
</template>